import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_VERSION_OUTPUTS_COLUMN_ID } from "../constants";
import { ModuleVersionOutputRow } from "../types";
import ModuleVersionOutputsTableDescriptionCell from "./DescriptionCell";
import ModuleVersionOutputsTableNameCell from "./NameCell";

export const MODULE_VERSION_OUTPUTS_TABLE_CELLS: Record<
  MODULE_VERSION_OUTPUTS_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionOutputRow>) => JSX.Element
> = {
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.NAME]: ModuleVersionOutputsTableNameCell,
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.DESCRIPTION]: ModuleVersionOutputsTableDescriptionCell,
};
